/**
 * @extends storeLocator.StaticDataFeed
 * @constructor
 */
 var urlCsv = $('#csvpath').attr('data-path');
 //console.log(urlCsv); 
function UnicoDataSource(xlab_reseller) {
  var url = "https://1117015.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=2838&deploy=1&compid=1117015&ns-at=AAEJ7tMQFAvkMfW4cJSxfvrvlXo-xKfXC9kWLAqn40JNZzeHAbI&brandfld=custentity_lifespandealer";
  const params = new URLSearchParams(window.location.search);

  if (params.get('xlab') === 'true' && params.get('xds') === 'false') {
    url += '&xlab_reseller=true'
  } 
  $.extend(this, new storeLocator.StaticDataFeed);
  var that = this;
    $.ajax({
        type: "POST",
        url: url,
        data: "data",
        dataType: "jsonp",
        beforeSend: function() {},
        success: function(E) {
            that.setStores(that.parse_(E));
        },
        error: function(I, P) {console.log("Error occured while get dealer list");}
    });
}

/**
 * @const
 * @type {!storeLocator.FeatureSet}
 * @private
 */
UnicoDataSource.prototype.FEATURES_ = new storeLocator.FeatureSet(
	new storeLocator.Feature('State-VIC', 'VIC'),
	new storeLocator.Feature('State-NSW', 'NSW'),
	new storeLocator.Feature('State-QLD', 'QLD'),
	new storeLocator.Feature('State-WA', 'WA'),
	new storeLocator.Feature('State-SA', 'SA'),
	new storeLocator.Feature('State-TAS', 'TAS'),
	new storeLocator.Feature('State-ACT', 'ACT'),
	new storeLocator.Feature('State-NT', 'NT')
);

/**
 * @return {!storeLocator.FeatureSet}
 */
UnicoDataSource.prototype.getFeatures = function() {
  return this.FEATURES_;
};

/**
 * @private
 * @param {string} csv
 * @return {!Array.<!storeLocator.Store>}
 */
UnicoDataSource.prototype.parse_ = function(datas) {
    var stores = [];
    var data = datas.stores;
    //console.log(data);
  // var datas = csv.split('\n');
  // var headings = this.parsedata_(datas[0]);
    console.log(data.length)
    for (var i = 0; i < data.length; i++) {
        // console.log(data[i]);
        var features = new storeLocator.FeatureSet;
        features.add(this.FEATURES_.getById('State-' + data[i].state));

        var position = new google.maps.LatLng(data[i].latitude, data[i].longtitude);
        var monday = data[i].hours_mon;
        var tuesday = data[i].hours_tue;
        var wednesday = data[i].hours_wed;
        var thursday = data[i].hours_thu;
        var friday = data[i].hours_fri;
        var saturday = data[i].hours_sat;
        var sunday = data[i].hours_sun;
        
        var shopName = "<h3 class='title'>"+data[i].storename+"</h3>";
        var shopAddress = "<p class='address'>"+data[i].full_address+"</p>";
        var number = "<p><strong>PH: </strong> "+data[i].store_phone+"</p>";
        var logos = "<span class='xds'></span>";
        if (data[i].xlab_reseller) {
            logos += "<span class='xlab'></span>";
        }

        var mon = '<span>Monday: </span>'+ monday+'<br>';
        var tue = '<span>Tuesday: </span>'+ tuesday+'<br>';
        var wed = '<span>Wednesday: </span>'+ wednesday+'<br>';
        var thu = '<span>Thursday: </span>'+ thursday+'<br>';
        var fri = '<span>Friday: </span>'+ friday+'<br>';
        var sat = '<span>Saturday: </span>'+ saturday+'<br>';
        var sun = '<span>Sunday: </span>'+ sunday;

        var store = new storeLocator.Store(i, position, features, {
            store_each: shopName+" "+shopAddress+" "+number+" "+logos,
            opening: this.join_(['<h5>OPENING HOURS</h5><div class="hours">'+mon+''+tue+''+wed+''+thu+''+fri+''+sat+''+sun+"</div>"]),
            links: '<a class="links-each" target="_blank" href="https://www.google.com.au/maps/dir/?api=1&destination='+data[i].latitude+','+data[i].longtitude+'"><strong>GET DIRECTIONS</strong> &gt;</a>'
        });
        stores.push(store);
    }
    // console.log(stores)
    return stores;
};

/**
 * Joins elements of an array that are non-empty and non-null.
 * @private
 * @param {!Array} arr array of elements to join.
 * @param {string} sep the separator.
 * @return {string}
 */
UnicoDataSource.prototype.join_ = function(arr, sep) {
  var parts = [];
  for (var i = 0, ii = arr.length; i < ii; i++) {
    arr[i] && parts.push(arr[i]);
  }
  return parts.join(sep);
};

/**
 * Very rudimentary CSV parsing - we know how this particular CSV is formatted.
 * IMPORTANT: Don't use this for general CSV parsing!
 * @private
 * @param {string} data
 * @return {Array.<string>}
 */
UnicoDataSource.prototype.parsedata_ = function(data) {
  // Strip leading quote.
  if (data.charAt(0) == '"') {
    data = data.substring(1);
  }
  // Strip trailing quote. There seems to be a character between the last quote
  // and the line ending, hence 2 instead of 1.
  if (data.charAt(data.length - 2) == '"') {
    data = data.substring(0, data.length - 2);
  }

  data = data.split('","');

  return data;
};

/**
 * Creates an object mapping headings to data elements.
 * @private
 * @param {Array.<string>} headings
 * @param {Array.<string>} data
 * @return {Object}
 */
UnicoDataSource.prototype.toObject_ = function(headings, data) {
  var result = {};
  for (var i = 0, ii = data.length; i < ii; i++) {
    result[headings[i]] = data[i];
  }
  return result;
};
